/**
 * Canonical event names. Must match ANALYTICS_EVENT_NAME in tours-api — the
 * ingest endpoint rejects anything else, deliberately, so two producers cannot
 * invent two spellings of the same event.
 */
export const ANALYTICS_EVENT_NAME = {
  pageView: 'page_view',
  uiClick: 'ui_click',
} as const;

export type AnalyticsEventName =
  (typeof ANALYTICS_EVENT_NAME)[keyof typeof ANALYTICS_EVENT_NAME];

/** Matches `source` in tours-api's AnalyticsEvent model. */
export const ANALYTICS_SOURCE_PORTAL = 'portal' as const;

/** Redacted, structural detail. Never raw text a user typed or a record's data. */
export type AnalyticsProperties = Record<
  string,
  string | number | boolean | null | string[]
>;

/** One action queued for reporting. */
export interface AnalyticsEvent {
  source: typeof ANALYTICS_SOURCE_PORTAL;
  eventName: AnalyticsEventName;
  path: string;
  sessionId: string;
  occurredAt: string;
  properties?: AnalyticsProperties;
}
